import { render, staticRenderFns } from "./tabManager.vue?vue&type=template&id=6030420e&scoped=true&"
import script from "./tabManager.vue?vue&type=script&lang=js&"
export * from "./tabManager.vue?vue&type=script&lang=js&"
import style0 from "./tabManager.vue?vue&type=style&index=0&id=6030420e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6030420e",
  null
  
)

component.options.__file = "tabManager.vue"
export default component.exports